/**
 * Checks if a decision point is an auto-continue point (structural link rather than an actual user choice)
 * Variant A enforces strict check: both decisionText and choiceText must be 'Continue'
 */
export function isAutoContinueDecisionPoint(dp) {
    if (!dp)
        return false;
    return (dp.decisionText === "Continue" &&
        Array.isArray(dp.branches) &&
        dp.branches.length === 1 &&
        dp.branches[0]?.choiceText === "Continue");
}
